import { ProjectDomUtils } from "../../utils/ProjectDomUtils";
import { DomUtils } from "socios-tools/utils/DomUtils";
export class ScriptAdapter {
    constructor(contextWindow, contextDocument) {
        this._contextWindow = contextWindow;
        this._contextDocument = contextDocument;
    }
    runScript(script, global = '') {
        let scriptElem = DomUtils.createElement('<div>' + script + '</div>');
        this._contextDocument.head.appendChild(scriptElem);
        ProjectDomUtils.runScripts(scriptElem);
        if (global) {
            return ProjectDomUtils.waitForData(global, this._contextWindow);
        }
        else {
            return Promise.resolve(undefined);
        }
    }
    init(params) {
    }
    initLazy() {
    }
    isReady() {
        return Promise.resolve(undefined);
    }
}
